module.exports = __webpack_public_path__ + "static/img/scroll_pizza_1.60a09dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/scroll_pizza_1.png
// module id = S3wv
// module chunks = 0